import { useRef } from "react";

import { sanitizer } from "@/components/html/sanitize";

import { StyledLWC } from "./lwc.styles";

export const LWC = ({ data }: { data: string }) => {
  const htmlRef = useRef<HTMLDivElement>(null);

  setTimeout(() => {
    if (!htmlRef.current) return;

    function showFirstPeriod() {
      const options = htmlRef.current?.querySelectorAll("#periodSelector option");
      if (options) {
        showTablesForPeriod(options[0].getAttribute("value"));
      }
    }

    function showTablesForPeriod(period: string | null) {
      const bodies = htmlRef.current?.querySelectorAll("tbody");
      for (let i = 0; i < (bodies?.length ?? 0); i++) {
        const body = bodies?.[i];
        if (!body) return;
        const status = body.getAttribute("class");
        const statusIE = body.getAttribute("className");
        if (status === period || statusIE === period) {
          body.style.display = "table-row-group";
          body.style.visibility = "visible";
        } else {
          body.style.display = "none";
          body.style.visibility = "hidden";
        }
      }
    }

    showFirstPeriod();
    const periodSelector = htmlRef.current.querySelector("#periodSelector");
    periodSelector?.removeAttribute("onchange");
    periodSelector?.addEventListener("change", (e) => {
      showTablesForPeriod((e.target as HTMLSelectElement).value);
    });
  }, 100);

  return (
    <StyledLWC
      translate="no"
      dangerouslySetInnerHTML={{ __html: sanitizer(data) }}
      ref={htmlRef}
    />
  );
};
